var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-welcome" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.$slots.input
      ? _c("div", { staticClass: "viq-welcome__input" }, [_vm._t("input")], 2)
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-welcome__suggestions" },
      _vm._l(_vm.suggestedCards, function (item, i) {
        return _c(
          "div",
          {
            key: i,
            staticClass: "viq-welcome__card",
            on: {
              click: function ($event) {
                return _vm.askSuggestion(item.question)
              },
            },
          },
          [
            _c("span", { staticClass: "viq-welcome__card-category" }, [
              _vm._v(_vm._s(item.category)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "viq-welcome__card-question" }, [
              _vm._v(_vm._s(item.question)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "viq-welcome__hero" }, [
      _c("h1", { staticClass: "viq-welcome__title" }, [
        _vm._v("Ask a Question"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "viq-welcome__subtitle" }, [
        _vm._v(
          "\n      Click a suggestion or type your own question below\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }